import React from 'react';
import { Box, Typography } from '@mui/material';
import LoaderCircular from '../loader/LoaderCircular';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import ProgressLoader from '../loader/ProgressLoader';
import LoaderIcon from '../loader/LoaderIcon';

function FeedbackContent({ feedback, text }) {
  return (
    <>
      <Typography variant="h5" color="primary" className="mt-12">
        {feedback}
      </Typography>
      <Typography variant="body2" className="mt-2">
        {text}
      </Typography>
    </>
  );
}

const renderContent = (type, feedback, text, loaderSize) => {
  switch (type) {
    case 'loader':
      return (
        <>
          {/* <LoaderCircular color="secondary" size={loaderSize ? loaderSize : null} /> */}
          <LoaderIcon />
          <FeedbackContent feedback={feedback} text={text ? text : 'Please wait...'} />
        </>
      );

    case 'error':
      return (
        <>
          <CancelRoundedIcon color="error" sx={{ fontSize: '48px' }} />
          <FeedbackContent feedback={feedback} text={text ? text : 'Please try again later. If the problem persists, contact support.'} />
        </>
      );

    case 'success':
      return (
        <>
          <CheckCircleRoundedIcon color="success" sx={{ fontSize: '48px' }} />
          <FeedbackContent feedback={feedback} text={text ? text : 'Operation successful'} />
        </>
      );

    case 'warning':
      return (
        <>
          <ErrorRoundedIcon color="warning" sx={{ fontSize: '48px' }} />
          <FeedbackContent feedback={feedback} text={text ? text : 'Operation successful, but with warnings'} />
        </>
      );

    default:
      return (
        <>
          <LoaderIcon />
          <Typography variant="h5" color="primary" className="mt-12">
            {feedback}
          </Typography>
          <Typography variant="subtitle1" className="mt-2">
            {text ? text : 'Please wait...'}
          </Typography>
        </>
      );
  }
};

export default function Feedback({ feedback, type, sx, text, loaderSize }) {
  return (
    <Box
      sx={{
        width: '300px',
        height: '250px',
        backgroundColor: 'background.paper',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 2,
        padding: '20px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        ...sx
      }}
    >
      {renderContent(type, feedback, text, loaderSize)}
      {type !== 'loading' && type && <ProgressLoader />}
    </Box>
  );
}
